//TODO: implement in CBT-4867 (https://hello.jira.atlassian.cloud/browse/CBT-4867)
export const useContentJiraWorkItems = () => {
	return {
		data: { jiraWorkItemsCount: 2 },
		error: null,
		refetch: () => {},
	};
};
